module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/021-cook-islands-1b796fa9e99a8623e26f2e12d1e14c20.svg";